import { render, staticRenderFns } from "./BackgroundOverall.vue?vue&type=template&id=8585dbba&scoped=true"
import script from "./BackgroundOverall.vue?vue&type=script&lang=js"
export * from "./BackgroundOverall.vue?vue&type=script&lang=js"
import style0 from "./BackgroundOverall.vue?vue&type=style&index=0&id=8585dbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8585dbba",
  null
  
)

export default component.exports